import { createAsyncThunk } from "@reduxjs/toolkit";
import { apiFetch } from '@/lib/api-fetch';
import { AdviserShareRequest } from "@syfo/types/api.client.types";
import { VaultDocument, SendVaultMeta } from "@syfo/types/vault.types";

interface SendToAdviserPayload {
  adviserEmail: string;
  vaultData: VaultDocument;
  meta: SendVaultMeta;
}

interface SendToAdviserResponse {
  success: boolean;
  shareId?: string;
  timestamp?: string;
}

/**
 * Thunk to send selected vault data to a financial adviser
 */
export const sendToAdviserThunk = createAsyncThunk<SendToAdviserResponse, SendToAdviserPayload>(
  'adviser/sendData',
  async ({ adviserEmail, vaultData, meta }, { rejectWithValue }) => {
    try {
      const requestBody: AdviserShareRequest = {
        adviserEmail,
        vaultData,
        meta
      };

      const response = await apiFetch('/api/adviser/share', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(requestBody)
      });

      if (!response.ok) {
        const error = await response.json();
        return rejectWithValue(error.message || 'Failed to share vault data');
      }

      const data = await response.json();
      return data as SendToAdviserResponse;
    } catch {
      return rejectWithValue('Network error: Unable to share vault data');
    }
  }
);
